import { get, put } from '../index'

export default {
  get: () => get('me'),
  update: (config) => put('me', config)
}
